import React, { useEffect, useState } from 'react';
import { Control, UseFormSetValue } from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import { SelectOption } from '../../../../../../components/Select';
import { CreateJobDto } from '../../../../../../services/applicant_tracking/JobService/CreateJobDto';
import { LabelledSelectFormHook } from '../../../../../../components/LabelledSelectFormHook';
import { LocationService } from '../../../../../../services/applicant_tracking/LocationService';
import { CreateLocationModal } from './CreateLocationModal';
import { IconButton } from '../../../../../../components/IconButton';
import { Alert, AlertType } from '../../../../../../components/Alert';

interface PropTypes {
  options: SelectOption[];
  formControl: Control<CreateJobDto>;
  defaultValue?: string;
  setLocationOptions: (selectedOption: SelectOption[]) => void;
  setIsLoading: (isLoading: boolean) => void;
  setValue: UseFormSetValue<CreateJobDto>;
}

export async function loadLocationOptions(): Promise<SelectOption[]> {
  return (await LocationService.list()).map((location) => ({
    value: location.id.toString(),
    label: location.name,
  }));
}

export function LocationInput(props: PropTypes) {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedLocation, setSelectedLocation] = useState<SelectOption>(null);
  const [isAlertVisible, setIsAlertVisible] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<AlertType>(AlertType.Success);
  const [alertMessage, setAlertMessage] = useState<JSX.Element>(null);
  const required = true;

  useEffect(() => {
    if (selectedLocation) {
      props.setValue('locationId', selectedLocation.value, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  }, [selectedLocation]);

  return (
    <>
      {isModalOpen && (
        <CreateLocationModal
          setIsModalOpen={setIsModalOpen}
          setLocationOptions={props.setLocationOptions}
          setIsLoading={props.setIsLoading}
          isModalOpen={isModalOpen}
          setSelectedLocation={setSelectedLocation}
          setAlertType={setAlertType}
          setAlertMessage={setAlertMessage}
          setIsAlertVisible={setIsAlertVisible}
        />
      )}
      {isAlertVisible && (
        <Alert
          type={alertType}
          clearable={true}
          autoClearTimeout={4000}
          onClose={() => setIsAlertVisible(false)}
        >
          {alertMessage}
        </Alert>
      )}
      <Row className='mt-4'>
        <Col xs={3}>
          <LabelledSelectFormHook<CreateJobDto>
            label={'Location'}
            placeholder={'Select Location'}
            formHookContext={{
              controllerName: 'locationId',
              formControl: props.formControl,
              required: required,
            }}
            options={props.options}
          />
        </Col>
        <Col xs={3} className='ps-0' style={{ marginTop: 'auto' }}>
          <IconButton
            buttonText='Create Location'
            iconName='bi-plus-circle'
            color='borderless'
            onClick={() => setIsModalOpen(true)}
          />
        </Col>
      </Row>
    </>
  );
}
